export default "__VITE_ASSET__D$phJC4k__"